import { getOptionValue, namedToOptionDeleted } from 'services/helpers';

import {
  setDelayAmount,
  checkDeleted,
  nameDescriptor,
} from 'pages/AutomationEngine/helpers';

import { AUTOMATION_STEPS } from 'pages/AutomationEngine/steps';

const forApi = (orgDetails) => {
  const { surveyId, delayAmount } = orgDetails;
  return {
    stepGoal: {
      ...orgDetails,
      delayAmount: setDelayAmount(delayAmount),
      triggers: [
        {
          type: AUTOMATION_STEPS.survey_submitted.type,
          triggerSurveySubmitted: {
            surveyId: getOptionValue(surveyId),
          },
        },
      ],
    },
  };
};

const forFlow = (firstTrigger, addErrorMessage, messageDictionary) => {
  const { survey } = firstTrigger.triggerSurveySubmitted || {
    survey: { id: null, label: null },
  };

  const surveyId = namedToOptionDeleted(survey);
  const type = AUTOMATION_STEPS.survey_submitted_goal.type;
  if (!firstTrigger.triggerSurveySubmitted) {
    // missing survey, after import
    addErrorMessage(messageDictionary.automationFailedToLoad);
  } else {
    checkDeleted(messageDictionary, addErrorMessage, survey, nameDescriptor);
  }
  return { surveyId, type };
};

export const surveySubmittedGoalDTO = {
  forApi,
  forFlow,
};
